import {
  TableCell,
  TableHead as TableHeadMUI,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { OrderDirection } from "~/operations";
import { Header } from "~/types/table";
import { useSort } from "../../hooks/useSort";

interface AdvisoriesTableHeadProps {
  tableHeaders: Header[];
  sort?: ReturnType<typeof useSort>;
  onSort?: (id: string) => void;
  orderBy?: {
    field: string;
    direction: string;
  };
}

export const TableHead = ({
  tableHeaders,
  sort,
  orderBy = sort?.orderBy,
  onSort,
}: AdvisoriesTableHeadProps) => {
  return (
    <TableHeadMUI>
      <TableRow>
        {tableHeaders.map((header) => (
          <TableCell
            key={header.id}
            align={header.options?.textAlign}
            width={header.options?.width}
            sx={{ whiteSpace: "nowrap" }}
          >
            {header.sortable !== false ? (
              <TableSortLabel
                component={sort?.baseUrl ? RouterLink : "span"}
                to={
                  sort?.baseUrl ? sort.sortColumnUrl(header.id).href : undefined
                }
                onClick={() => onSort?.(header.id)}
                direction={
                  orderBy?.direction === OrderDirection.Asc ? "asc" : "desc"
                }
                active={header.id === orderBy?.field}
              >
                {header.label}
              </TableSortLabel>
            ) : (
              header.label
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHeadMUI>
  );
};
